export default function About() {
  return (
    <section id="about" className="py-24 px-6 bg-amber-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="lg:pl-12">
            <p className="text-xs text-red-800 tracking-widest mb-4 font-semibold">ABOUT US</p>
            <h2 className="text-5xl font-bold text-gray-900 mb-8" style={{ fontFamily: 'serif' }}>
              私たちのこだわり
            </h2>
            <div className="space-y-6 text-gray-700 leading-relaxed">
              <p>
                2026年1月、東京・足立区東伊興に「RAMEN鶴」が誕生します。
                地域の皆様に愛される一杯を目指し、オープンの日を心待ちにしながら準備を重ねています。
              </p>
              <p>
                スープは豚骨と鶏ガラをじっくり炊き上げ、深いコクと旨味を丁寧に引き出しました。
                麺は特注の中太麺を使用し、スープとの絶妙なバランスにこだわっています。
              </p>
              <p>
                「また来たい」と思っていただける一杯を、真心を込めてお届けします。
                2026年1月19日のグランドオープンを、どうぞお楽しみに。
              </p>
            </div>
            <p className="mt-10 text-xl text-gray-600" style={{ fontFamily: 'cursive' }}>
              店主より
            </p>
          </div>

          <div className="relative h-[600px]">
            <div className="absolute inset-0 rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://storage.readdy-site.link/project_files/27323ae1-124e-4138-8b60-38dc257bd150/a5fdab0a-8ad2-419e-b1c8-f24c72021b9e_S__15589384.jpg?v=f23104e293bb4603733671eb0382465b"
                alt="ラーメン調理"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
